var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "套餐id",
                            prop: "projectSetsId",
                            rules: [
                              {
                                required: true,
                                message: "套餐id不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写套餐id" },
                            model: {
                              value: _vm.inputForm.projectSetsId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "projectSetsId", $$v)
                              },
                              expression: "inputForm.projectSetsId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "sort", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写排序" },
                            model: {
                              value: _vm.inputForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "sort", $$v)
                              },
                              expression: "inputForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "父id", prop: "parentId", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写父id" },
                            model: {
                              value: _vm.inputForm.parentId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "parentId", $$v)
                              },
                              expression: "inputForm.parentId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "等级", prop: "grade", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写等级" },
                            model: {
                              value: _vm.inputForm.grade,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "grade", $$v)
                              },
                              expression: "inputForm.grade",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "字典id",
                            prop: "dictValueId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写字典id" },
                            model: {
                              value: _vm.inputForm.dictValueId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "dictValueId", $$v)
                              },
                              expression: "inputForm.dictValueId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文名称",
                            prop: "nameEn",
                            rules: [
                              {
                                required: true,
                                message: "英文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写英文名称" },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文名称",
                            prop: "nameCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写中文名称" },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "功能空间ids",
                            prop: "functionalSpaceIds",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写功能空间ids" },
                            model: {
                              value: _vm.inputForm.functionalSpaceIds,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "functionalSpaceIds",
                                  $$v
                                )
                              },
                              expression: "inputForm.functionalSpaceIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "功能空间内容ids",
                            prop: "functionSpacePositionIds",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写功能空间内容ids" },
                            model: {
                              value: _vm.inputForm.functionSpacePositionIds,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "functionSpacePositionIds",
                                  $$v
                                )
                              },
                              expression: "inputForm.functionSpacePositionIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "简介(中)",
                            prop: "introductionCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写简介(中)" },
                            model: {
                              value: _vm.inputForm.introductionCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "introductionCn", $$v)
                              },
                              expression: "inputForm.introductionCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "简介(英)",
                            prop: "introductionEn",
                            rules: [
                              {
                                required: true,
                                message: "简介(英)不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写简介(英)" },
                            model: {
                              value: _vm.inputForm.introductionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "introductionEn", $$v)
                              },
                              expression: "inputForm.introductionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "标签ids",
                            prop: "tagsIds",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写标签ids" },
                            model: {
                              value: _vm.inputForm.tagsIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "tagsIds", $$v)
                              },
                              expression: "inputForm.tagsIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联套餐空间id",
                            prop: "setsPositionId",
                            rules: [
                              {
                                required: true,
                                message: "关联套餐空间id不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写关联套餐空间id" },
                            model: {
                              value: _vm.inputForm.setsPositionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "setsPositionId", $$v)
                              },
                              expression: "inputForm.setsPositionId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联字典空间id",
                            prop: "positionId",
                            rules: [
                              {
                                required: true,
                                message: "关联字典空间id不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写关联字典空间id" },
                            model: {
                              value: _vm.inputForm.positionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "positionId", $$v)
                              },
                              expression: "inputForm.positionId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "价格", prop: "price", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写价格" },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }